import dayjs from "dayjs";

/**比较两个时间，如果大鱼duration 20s则返回false */
export const compareTime = (startTime: string, endTime: string, duration = 20) => {
    return dayjs(endTime).diff(dayjs(startTime), "second") > duration;
};

export const formatTime = (time: any) => {
    return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};
